import React from "react";

interface Props {
  progressPerecentage: string;
  completionText: string | null;
}

const CaregiverSurveyProgress = (props: Props) => {
  return (
    <div className="CaregiverSurveyProgress">
      <div className="statusContainer">
        <div className="progressBar">
          <div style={{ width: props.progressPerecentage }} />
        </div>
        <div className="progressText">{props.completionText}</div>
      </div>
    </div>
  );
};

export default React.memo(CaregiverSurveyProgress);
